import { useEffect, useRef } from 'react'

/**
 * Escape schließt das Blatt, das gerade obenauf liegt.
 *
 * Aus der Codereview (0.29.0): derselbe Zuhörer stand neunmal da, Zeichen
 * für Zeichen. Ein Blatt, das nur auf das X hört, ist am Rechner eine
 * Sackgasse; deshalb hat jedes ihn, und deshalb steht er jetzt einmal hier.
 *
 * `null` schaltet ihn ab: die Rückfrage hört nur, solange eine Frage offen
 * ist.
 *
 * **Only the top layer gets the key** (1.101.0, review). Every layer
 * listened on `window`, where nothing bubbles that could be stopped, and
 * each pair solved it its own way: the spot's sheet listened in the capture
 * phase and stopped the key -- so with a photo open over it, Escape closed
 * the sheet underneath and left the photo standing; the point's sheet asked
 * the DOM for `.lightbox`; a question over a sheet closed both. Now the
 * layers stand in one stack in the order they opened, and one listener
 * hands the key to the last. A layer that changes its callback keeps its
 * place (`useRef`): only opening and closing move it.
 */
const stapel: { zu: () => void }[] = []

function taste(event: KeyboardEvent): void {
  if (event.key !== 'Escape') return
  const oben = stapel[stapel.length - 1]
  if (oben === undefined) return
  event.preventDefault()
  oben.zu()
}

export function useEscape(zu: (() => void) | null): void {
  const aktuell = useRef(zu)
  aktuell.current = zu
  const offen = zu !== null
  useEffect(() => {
    if (!offen) return
    const eintrag = { zu: () => aktuell.current?.() }
    stapel.push(eintrag)
    if (stapel.length === 1) window.addEventListener('keydown', taste)
    return () => {
      const stelle = stapel.indexOf(eintrag)
      if (stelle >= 0) stapel.splice(stelle, 1)
      if (stapel.length === 0) window.removeEventListener('keydown', taste)
    }
  }, [offen])
}
